/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import BrandedBootLoader from "Components/common/BrandedBootLoader";
import { dealifyPopupStore } from "./DealifyPopup";

const LoggedInDealify = props => {
  useEffect(() => {
    dealifyPopupStore.showPopup = true;
    props.history.push("/dashboard");
  }, []);

  return <BrandedBootLoader />;
};

export { LoggedInDealify };
export default withRouter(LoggedInDealify);
